import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstance } from '../../Apis/Axios';
import { LOG_SERVICE } from '../EndPoints';
import apiInstanceV2 from '../../Apis/AxiosV2';

export const GetCrudLogList = createAsyncThunk('logSlice/getCrudLogList', async (body, { dispatch, getState }) => {
    const result = await apiInstance
        .post(LOG_SERVICE.getCrudLogList, body)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const GetLoginLogList = createAsyncThunk('logSlice/getLoginLogList', async (body, { dispatch, getState }) => {
    const result = await apiInstance
        .post(LOG_SERVICE.getLoginLogList, body)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const GetWorkOffice = createAsyncThunk(
    'logSlice/getWorkOffice',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(LOG_SERVICE.getWorkOffice)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

export const CheckInWorkOffice = createAsyncThunk(
    'logSlice/checkInWorkOffice',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post(LOG_SERVICE.checkInWorkOffice, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const CheckOutWorkOffice = createAsyncThunk(
    'logSlice/checkOutWorkOffice',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(LOG_SERVICE.checkOutWorkOffice, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);


export const GetUserAccessList = createAsyncThunk(
    'logSlice/getUserAccessList',
    async (body, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post(LOG_SERVICE.getUserAccessList, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);


export const getAllUserAccessLogByUserId = createAsyncThunk(
    'logSlice/getAllUserAccessLogByUserId',
    async (params, { dispatch, getState }) => {
        const {userId, pagination}=params;
        const result = await apiInstanceV2
            .post(`${LOG_SERVICE.getAllUserAccessLogByUserId}${userId}`,pagination)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const GetVehicleAccessList = createAsyncThunk(
    'logSlice/getVehicleAccessList',
    async (body, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post(LOG_SERVICE.getVehicleAccessList, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);


export const getAllVehicleAccessLogByVehicleId = createAsyncThunk(
    'logSlice/getAllVehicleAccessLogByVehicleId',
    async (params, { dispatch, getState }) => {
        const {vehicleId, pagination}=params;
        const result = await apiInstanceV2
            .post(`${LOG_SERVICE.getAllVehicleAccessLogByVehicleId}${vehicleId}`,pagination)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const UpdateAccessComment = createAsyncThunk(
    'logSlice/updateAccessComment',
    async (body, { dispatch, getState }) => {

        const result = await apiInstance
            .put(LOG_SERVICE.updateAccessComment, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    }
);

